import React, { useState, useEffect } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';

export default function TextEditor({value, returnChange, height = true}) {
  const [content, setContent] = useState(value)

  useEffect(() => {
    setContent(value)
  }, [value])

  useEffect(() => {
    returnChange(content)
  }, [content])

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false]}],
      ["bold", "italic", "underline", "strike"],
      [
        { list: "ordered" },
        { list: "bullet"  }
      ],
      ["link", "image", "video"]
    ]
  }

  return (
    <div>
      {height &&
        <div style={{height: "320px"}}>
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            className="editor-state"
            modules={modules}
          />
        </div>
      }

      {!height &&
        <div style={{height: 'fit-content'}}>
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            className="editor-state"
            modules={modules}
          />
        </div>
      }
    </div>
  )
}
